import { render, staticRenderFns } from "./wechatBand.vue?vue&type=template&id=c8e31df8"
import script from "./wechatBand.vue?vue&type=script&lang=js"
export * from "./wechatBand.vue?vue&type=script&lang=js"
import style0 from "./wechatBand.vue?vue&type=style&index=0&id=c8e31df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports